import { BaseField } from "../base-field";

export class HiddenField<T = any> extends BaseField<T> {

  constructor(init: Partial<HiddenField<T>>) {
    super('Hidden', init);

  }
}
